module.exports = __webpack_public_path__ + "img/game-card.1e4c74b.webp";